import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {get, set, isEqual, merge, omit, pick, isNil, find, has} from 'lodash';
import * as surveyApi from '../../../redux/actionCreators/async/v2/applicants/technology';
import * as surveyStore from '../../../redux/actionCreators/sync/technologysurveys';
import * as uiStore from '../../../redux/actionCreators/sync/ui';
import {validateObject} from '../../../lib/validation/validator';
import {schema} from '../../../models/applicantTechSurvey';
import TechnologySurveyForm from './TechnologySurveyForm';

@connect(store => ({
  user: store.user,
  labels: get(store.labels, 'ApplicantTechnologySurvey', {}),
  profile: store.applicantProfile,
  staticData: store.staticData,
  technologySurvey: store.technologySurvey,
}))
export default class TechnologySurveyContainer extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    technologySurvey: PropTypes.object.isRequired,
    adminView: PropTypes.bool,
    labels: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = this.initState(props);
    this.localStash = {};
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.technologySurvey, this.props.technologySurvey)) {
      this.setState(omit(this.initState(nextProps), ['errors']));
    }
  }

  initLabels(props) {
    return {
      computerTypeId: props.adminView ? 'Computer Type' : 'What type of computer do you plan on using as your main workstation?',
      computerMakeAndModel: props.adminView ? 'Make and model' : 'What is the make and model?',
      windowsOperatingSystemId: props.adminView ? 'Windows Version' : 'Windows Version',
      computerOperatingSystemId: props.adminView ? 'PC or Other (Mac, Chromebook, etc.)' : 'Is your computer a PC or Other (Mac, Chromebook, etc.)?',
      windowsUpdatingRegularly: props.adminView ? 'MS Windows Software updating regularly' : 'Is your MS Windows Software updating regularly and running properly?',
      computerMemorySizeId: props.adminView ? 'GigaBytes of RAM' : get(props, 'labels.computerMemorySizes', 'GigaBytes of RAM'),
      hasSecondMonitor: props.adminView ? 'Has a second monitor' : 'Do you have a second monitor?',
      displayConnectionTypeId: props.adminView ? 'Connection to add an additional monitor' : get(props, 'labels.displayConnectionType'),
      supportsSecondMonitor: props.adminView ? 'Laptop or PC supports additional monitor' : 'If you currently do not have a dual monitor, will your laptop or PC support one?',
      hasPrinterScanner: props.adminView ? 'Has printer/scanner' : 'Do you have a printer/scanner?',
      hasWebcam: props.adminView ? 'Has a webcam' : 'Do you have a webcam (camera & microphone)?',
      hasMSOfficeInstalled: props.adminView ? 'Microsoft Office installed' : 'Do you have Microsoft Office installed?',
      msOfficeVersionId: props.adminView ? 'Microsoft Office version' : get(props, 'labels.msOfficeVersion'),
      includesOutlook: props.adminView ? 'Includes Outlook' : 'Does it include Outlook?',
      msOfficeUpdatingRegularly: props.adminView ? 'MS Office installed updating regularly' : 'Is your MS Office Software updating regularly and running properly?',
      hasAntiVirusInstalled: props.adminView ? 'Anti-Virus software installed' : 'Do you have an Anti-Virus software installed you have paid for and is updated and currently protecting your workstation?',
      antiVirusName: props.adminView ? 'Name of the Anti-Virus Program' : 'What is the name of the Anti-Virus program currently installed?',
      antiVirusExpired: props.adminView ? 'Anti-Virus expiration date' : 'What date does the Anti-Virus protection expire?',
      antiVirusRenewedYearly: props.adminView ? 'Agrees to renew Anti-Virus software every year.' : 'You agree that you will renew your Anti-Virus software every year when it expires.',
      hasFirewallInstalled: props.adminView ? 'Firewall installed' : 'Is a firewall protecting your computer either through the Windows Firewall or your Anti-Virus software?',
      hasSkypeInstalled: props.adminView ? 'Skype or a similar program' : 'Do you use Skype or a similar type of program?',
      internetProviderId: props.adminView ? 'Internet Service provider' : get(props, 'labels.internetProvider'),
      internetProviderOther: 'If other, please specify',
      internetTypeId: props.adminView ? 'High-speed internet service type' : get(props, 'labels.internetType'),
      internetDownloadSpeed: props.adminView ? 'Internet download speed' : 'What is the internet download speed?',
      internetUploadSpeed: props.adminView ? 'Internet upload speed' : 'What is the internet upload speed?',
      internetAgeId: props.adminView ? 'Cable box/modem age' : 'How long have you had the current cable box/modem that controls your internet?',
      hasRouter: props.adminView ? 'Wireless router' : 'Do you have a wireless router?',
      routerAgeId: props.adminView ? 'Wireless router age' : 'How long have you had your wireless router?',
      routerMakeAndModel: props.adminView ? 'Make and model of your wireless router' : 'What is the make and model of your wireless router?',
      isRouterLocatedInSameArea: props.adminView ? 'Is your internet equipment in your home office?' : 'Is your internet equipment in your home office?',
      supportsVOIP: props.adminView ? 'Available Ethernet for (VOIP) phone' : 'Is there an Ethernet port in your modem or router that could be used to plug in an internet (VOIP) phone?',
      willingToUpgradeRouter: props.adminView ? 'Willing to upgrade you router' : 'If necessary, are you willing to upgrade your router?',
      windowsOSModal: props.adminView ? '' : 'To find your Windows version click [here].',
      windowsOSModalMessage: get(props, 'labels.windowsOSModalMessage'),
      computerMemorySizes: props.adminView ? '' : 'A minimum of 8 GB is required. Higher memory is recommended. To find your memory levels click [here].',
      computerMemorySizesMessage: 'A minimum of 8 GB is required. Higher memory is recommended. This information can be found by going to Control Panel, System and Security, System.',
      hasAntiVirus: props.adminView ? '' : 'Free antivirus are not acceptable, click [here] for info.',
      hasAntiVirusMessage: get(props, 'labels.freeAntiVirusModalMessage'),
      internetSpeeds: props.adminView ? '' : 'For more information on your internet speed, click [here]. Please enter your results including decimals, ex: 30.62',
      internetSpeedsMessage: 'You can find the speed by going to https://www.speakeasy.net/speedtest/ on your browser. Hit the big blue “Start” button and wait for the results. Enter your download speed and upload speed into the fields in the technology survey. Your results should be entered per this example. DL 46.5 UL 10.2',
      upgradeRouter: props.adminView ? '' : 'For more information on upgrading routers, click [here].',
      upgradeRouterMessage: `For the best connection possible, outdated equipment should be replaced.
                                  A cable modem from your internet provider is typically available to be
                                  swapped out at no charge. Router technology has advanced significantly
                                  in recent years and new models offer tremendous speed and reliability
                                  over their predecessors.`,
      titleText: props.adminView ? '' : (get(props, 'technologySurvey.dateCompleted', false) ? get(props, 'labels.completedTitleText') : get(props, 'labels.titleText')),
      instructionText: props.adminView ? '' : get(props, 'labels.InstructionText'),
      smartPhone: props.adminView ? 'Has Smart Phone' : get(props, 'labels.smartPhone'),
      smartPhoneMakeAndModel: props.adminView ? 'Smart Phone Make / Model' : get(props, 'labels.smartPhoneMakeAndModel'),
      cellProvider: props.adminView ? 'Cell Provider' : get(props, 'labels.cellProvider'),
      hotspot: props.adminView ? 'Has Hotspot' : get(props, 'labels.hotspot'),
      hasHeadsetWithMicrophone : get(props, 'labels.hasHeadsetWithMicrophone'),
      hasSpeakersWithMicrophone : get(props, 'labels.hasSpeakersWithMicrophone')
    };
  }

  onChange = (field, value) => {
    this.updateSurvey(field, value);
  }

  onSave = () => {
    this.saveSurvey();
  }

  onSubmit = () => {
    this.submitSurvey();
  }

  onModal = (note) => {
    this.displayModal(note);
  }

  initSurvey(technologySurvey) {
    return Object.assign({}, technologySurvey); // Clone
  }

  initState(props) {
    return {
      survey: this.initSurvey(props.technologySurvey),
      fieldLabels: this.initLabels(props),
      errors: {},
      modalMessage: null
    };
  }

  allowSubmit = () => {
    const [valid] = this.validate(this.state.survey);
    return (!this.props.technologySurvey.dateCompleted && valid);
  }

  updateSurvey(field, value) {

    const {survey, errors} = this.newState();
    survey[field] = value;

    // handle field dependencies and stash/pop so that we don't lose values on stray clicks...
    const stash = key => this.stash(key, survey[key]);
    const pop = key => isNil(survey[key]) ? this.pop(key) : survey[key];

    if (field === 'hasMSOfficeInstalled') {
      if (survey.hasMSOfficeInstalled) {
        survey.msOfficeVersionId = pop('msOfficeVersionId');
        survey.includesOutlook = pop('includesOutlook');
      } else {
        survey.msOfficeVersionId = stash('msOfficeVersionId');
        survey.includesOutlook = stash('includesOutlook');
      }
    }

    if (field === 'hasAntiVirusInstalled') {
      if (survey.hasAntiVirusInstalled) {
        survey.antiVirusExpired = pop('antiVirusExpired');
        survey.antiVirusName = pop('antiVirusName');
      } else {
        survey.antiVirusExpired = stash('antiVirusExpired');
        survey.antiVirusName = stash('antiVirusName');
      }
    }

    if (field === 'supportsSecondMonitor') {
      if (survey.supportsSecondMonitor) {
        survey.displayConnectionTypeId = pop('displayConnectionTypeId');
      } else {
        survey.displayConnectionTypeId = stash('displayConnectionTypeId');
      }
    }

    if (field === 'hasRouter') {
      if (survey.hasRouter) {
        survey.routerAgeId = pop('routerAgeId');
      } else {
        survey.routerAgeId = stash('routerAgeId');
      }
    }

    if (field === 'smartPhone') {
      if (survey.smartPhone) {
        survey.smartPhoneMakeAndModel = pop('smartPhoneMakeAndModel');
        survey.cellProvider = pop('cellProvider');
      } else {
        survey.smartPhoneMakeAndModel = stash('smartPhoneMakeAndModel');
        survey.cellProvider = stash('cellProvider');
      }
    }

    const [valid, newErrors] = this.validate(survey);
    const fields = [field, ...get(schema, `${field}.related`, [])];

    if (!valid) {
      this.setState(() => ({survey, errors: merge({}, omit(errors, fields), pick(newErrors, fields))}));
    } else {
      this.setState(() => ({survey, errors: omit(errors, fields)}));
    }
  }

  saveSurvey() {
    const {survey} = this.newState();
    const {dispatch, profile} = this.props;
    const [valid, errors] = this.validate(survey);
    if (!valid) {
      this.setState({errors});
    }

    dispatch(surveyApi.saveTechnologySurvey(profile.id, survey, (err, techSurvey) => {
      if (err) {
        this.displayWarning('Please check all fields are valid.');
        return;
      }

      dispatch(surveyStore.updateTechnologySurvey(techSurvey));
      dispatch(uiStore.showSnackBar('Changes are saved'));
    }));

  }

  submitSurvey() {
    const {survey} = this.newState();
    const {dispatch, profile} = this.props;
    const [valid] = this.validate(survey);
    if (!valid) {
      this.saveSurvey();
      return;
    }

    dispatch(surveyApi.submitTechnologySurvey(profile.id, survey, (err, techSurvey) => {
        if (err) {
          this.displayWarning(err.message);
          return;
        }

        dispatch(surveyStore.updateTechnologySurvey(techSurvey));
        dispatch(uiStore.showSnackBar('Survey submitted'));
      })
    );
  }

  validateWindowsOsField({ survey, errors, form}) {
    const osList = get(this.props, 'staticData.operatingSystemTypes');
    const osWindows = find(osList, { hardcodelink: 'PC' });

    const needsWindowsId =
      osWindows &&
      survey.computerOperatingSystemId === get(osWindows, 'id') &&
      isNil(survey.windowsOperatingSystemId) &&
      !has(errors, 'computerOperatingSystemId');

    if (needsWindowsId) {
      set(errors, 'windowsOperatingSystemId', ['This field is required.']);
      form.valid = false;
    }
  }

  validate(survey) {
    const form = validateObject(survey, schema);
    const errors = (typeof form.errors === 'string') ? {} : form.errors;
    this.validateWindowsOsField({ survey, errors, form });
    return [form.valid, errors];
  }

  displayWarning(warning) {
    const {dispatch} = this.props;
    return dispatch(uiStore.warningToast(warning));
  }

  displayModal(modalMessage = null) {
    return this.setState({modalMessage});
  }

  newState() {
    return Object.assign({}, this.state);
  }

  stash(key, value) {
    this.localStash[key] = value;
    return null;
  }

  pop(key) {
    return this.localStash[key];
  }

  render() {

    const {
      survey,
      errors,
      fieldLabels,
      modalMessage
    } = this.state;

    const {
      staticData,
      adminView
    } = this.props;

    return (
      <TechnologySurveyForm
        survey={survey}
        errors={errors}
        adminView={adminView}
        fieldLabels={fieldLabels}
        staticData={staticData}
        modalMessage={modalMessage}
        onChange={this.onChange}
        onSave={this.onSave}
        onSubmit={this.onSubmit}
        onModal={this.onModal}
        allowSubmit={this.allowSubmit()}
      />
    );

  }
}



// WEBPACK FOOTER //
// ./shared/react/applicant/TechnologySurvey/TechnologySurveyContainer.js